export default "__VITE_ASSET__DPgO2NoG__"